<template>
    <div id="assetMessage" :style="{ ...messageColors, ...(extendedStyle || {}) }" class="sc-message--text">
        <div class="media-content-wrapper">
            <a :href="getSrc()" download target="_blank">
                <div v-if="message.raw.asset.ext" :class="`fi-${message.raw.asset.ext}`" class="fi">
                    <div class="fi-content">{{ message.raw.asset.ext }}</div>
                </div>
                <p :class="message.author === 'me' ? 'received' : 'sent'" class="media-content-text">
                    {{ $t("message.download") }}
                </p>
            </a>
        </div>
        <span
            v-if="message.data.meta"
            :class="message.author === 'me' ? 'received' : 'sent'"
            class="sc-message--meta"
            >{{ message.data.meta }}</span
        >
    </div>
</template>

<script>
export default {
    name: "AssetMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getSrc() {
            const asset = this.message.raw.asset;
            const src =
                asset.path.indexOf("whatsapp") !== -1
                    ? `https://static.supsis.live/${asset.path}`
                    : `https://static.supsis.live/${asset.path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
            return src;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

#assetMessage {
    .media-content-wrapper {
        margin: 4px;

        .media-content-text {
            margin-bottom: 0;
            font-family: Poppins, monospace;
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
        }
    }

    .received {
        color: #222222;
    }

    .sent {
        color: #ffffff;
    }
}
</style>
